import React, { useEffect, useContext, useReducer } from 'react';
import TwoCards from '../../../../../components/Card/TwoCards';
import { useParams, useHistory } from 'react-router-dom';
import EditOrder from './EditOrder';
import LinearProgress from '@material-ui/core/LinearProgress';
import MainContext from '../../../../../store/MainContext';
import EditActions from './EditActions';
import ActionButtons from './ActionButtons';
import { initialState, reducer, actions, store } from './reducer';

const Order = () => {
  const { id: orderId } = useParams();
  const [state, dispatch] = useReducer(reducer, initialState);
  const { order } = state;
  const { Provider } = store;
  const {
    showMessage,
    showError,
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(MainContext);
  const history = useHistory();

  const loadOrder = async () => {
    try {
      const { data } = await actions.getOrder(orderId);
      data && dispatch({ type: 'ORDER', payload: data });
    } catch (error) {
      showError(error);
      history.replace('/protected/admin/orders/');
    }
  };
  const getLogs = async () => {
    try {
      const { data } = await actions.getLogs(orderId);
      if (data?.ok) {
        dispatch({ type: 'LOGS', payload: data?.logs });
      }
    } catch (error) {
      showError(error);
    }
  };
  const getCommissions = async () => {
    try {
      const { data } = await actions.getCommission(orderId);
      if (data?.ok) {
        dispatch({ type: 'COMMISSIONS', payload: data?.commissions });
      }
    } catch (error) {
      showError(error);
    }
  };

  const refresh = () => {
    loadOrder();
    getLogs();
    getCommissions();
  };

  useEffect(() => {
    refresh();
  }, [orderId]);

  return (
    <Provider
      value={{
        state,
        dispatch,
        actions,
        refresh: refresh,
        showError,
        showMessage,
        itemsCountPerPage,
      }}
    >
      <TwoCards
        title="ویرایش سفارش"
        category="درهنگام ویرایش دقت کنید. نتایج غیرقابل پیش بینی خواهند بود"
        secondaryTitle="مدیریت سفارش"
        secondaryCategory="جهت مدیریت سفارش"
        secondaryContent={<EditActions />}
        actions={order ? <ActionButtons /> : null}
      >
        {!!order ? <EditOrder order={order} refresh={refresh} /> : <LinearProgress />}
      </TwoCards>
    </Provider>
  );
};

export default React.memo(Order);
